/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Fee_Exceeds_ValueInputs */

const vi_error_return_fee_exceeds_value = /** @type {(inputs: Error_Return_Fee_Exceeds_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phí trả hàng không được âm hoặc lớn hơn giá trị hàng trả.`)
};

/**

* @param {Error_Return_Fee_Exceeds_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_fee_exceeds_value = /** @type {((inputs?: Error_Return_Fee_Exceeds_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Fee_Exceeds_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_fee_exceeds_value(inputs)
});